import React from 'react';
import { selectTextByLanguage, useGetAvailableLanguages } from '../../hooks/global/Languages';
import { useTranslation } from 'react-i18next';
import { downloadProfilesAndProductsList } from '../../helpers/csvFileHelpers';
import { useGetCurrentVendor } from '../../hooks/global/User';

const ListForm = ({ profiles, groups }) => {
    const { t, i18n } = useTranslation();

    const availableLanguages = useGetAvailableLanguages();
    const vendor = useGetCurrentVendor();

    const products = groups.flatMap(group =>
        group?.products.map(product => ({
            ...product,
            group_id: group.id
        }))
    );


    return (
        <>
            <h2 className="header-class">{t('admin.inv.listMTitle')}</h2>

            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>{t("csv.module")}</th>
                            <th>{t("csv.el")}</th>
                            <th>{t("csv.code")}</th>
                        </tr>
                    </thead>
                    <tbody>

                        {profiles && profiles.length > 0 && (
                            profiles.map((profile) => (
                                <tr key={profile.id}>
                                    <td width="250px">{profile.id}</td>
                                    <td>{t("admin.common.exp")}</td>
                                    <td>{selectTextByLanguage(profile.name, i18n.language, availableLanguages)}</td>
                                    <td><strong>{profile.id}</strong></td>
                                </tr>
                            ))
                        )}
                        {groups && groups.length > 0 && (
                            groups.map((group) =>
                                group.products.map((product) => (
                                    <tr key={product.id}>
                                        <td width="250px">{product.id}</td>
                                        <td>{selectTextByLanguage(group.descriptive_name, i18n.language, availableLanguages)}</td>
                                        <td>{selectTextByLanguage(product.name, i18n.language, availableLanguages)}</td>
                                        <td><strong>{product.source_id}</strong></td>

                                    </tr>
                                )))
                        )}
                    </tbody>
                </table>

                <button
                    className="btn btn-default btn-send btn btn-primary mt-2"
                    onClick={() => downloadProfilesAndProductsList(groups, profiles, products, vendor, availableLanguages, t, i18n.language, selectTextByLanguage)}
                >
                    {t("admin.inv.listkMSub")}
                </button>
            </div>
        </>
    );
};

export default ListForm;
